import * as firebase from "firebase";

class FirebaseService {
    /* Safely execute */
    static safeExecute(fn, context = '') {
        try {
            return fn();
        } catch (error) {
            console.error(`Error in ${context}:`, error);
            throw error;
        }
    }

    /* Safely execute for asynchronous functions */
    static async safeExecuteAsync(fn, context = '') {
        try {
          return await fn();
        } catch (error) {
          console.error(`Error in ${context}:`, error);
          throw error;
        }
    }

    // Generic method to create a Firebase reference
    static __reference(path) {
        return this.safeExecute(() => firebase.database().ref(path));
    }
}

export default FirebaseService;